import settings from '../../config/settings';
import axiosNonAuth from './axiosNonAuth';
import qs from 'qs';

const {apiBaseUrl} = settings;

export default class Api {
  static getProgram(id) {
    return axiosNonAuth.get(`${apiBaseUrl}/programs/${id}/`);
  }

  static findPrograms(query, page) {
    if (page) {
      query.page = page;
    }
    return axiosNonAuth.get(`${apiBaseUrl}/search/programs/?${qs.stringify(query)}`);
  }

  static getToplist() {
    return axiosNonAuth.get(`${apiBaseUrl}/top-programs/`);
  }

  static checkAirings(id, affiliateCallSign, card) {
    const data = {affiliateCallSign};
    if (card) {
      data.card = card;
    }
    return axiosNonAuth.post(`${apiBaseUrl}/programs/${id}/check-airings/`, data);
  }
}
